<app-cover-static-flash />
<app-why-love-flash />
<app-static-card-flash />
<!-- <section>
    <h1 class="mb-10 font-bold text-[#010128] text-2xl text-center xl:text-6xl lg:text-5xl md:text-4xl">Browse Flashcards by subjects</h1>
    <app-browse-subjects />
</section> -->
<app-explore-tools />
